import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Reach.css";

const Reach = () => {
  return (
    <section className="reach-section">
      <Container>
        <Row className="align-items-center">
          
          {/* LEFT CONTENT */}
          <Col md={6}>
            <div className="reach-content">
              <h2>
                Want to Reach More Fans & Boost Your Streams?
              </h2>

              <h3>
                VDNI Accelerator helps independent artists grow faster.
              </h3>

              <p>
                VDNI Accelerator empowers self-releasing artists to increase
                discoverability, reach global listeners, and scale their music career.
              </p>

              <p>
                Join thousands of artists who trust VDNI to amplify their reach
                and unlock new growth opportunities.
              </p>

              <Link to="/signup" className="reach-btn">
                Get Started
              </Link>
            </div>
          </Col>

          {/* RIGHT IMAGE */}
          <Col md={6} className="text-center">
            <div className="reach-img-wrapper">
              <img
                src="/Images/growth.png"
                alt="Grow with VDNI"
                className="reach-img"
              />
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default Reach;
